/* newtestdesign · product page (sections/ntd-product.liquid)
   pictures (thumbnails, swipe + dots) · option pills → the matching variant (price, stock, ?variant=)
   · quantity · Add to cart through the Cart API (ntd.js: NTD.addToCart → the drawer opens)
   · the phone bar with price + Add to cart once the main button has scrolled away. */
(function () {
  "use strict";
  var root = document.querySelector("[data-product]");
  if (!root) return;
  var NTD = window.NTD || {};
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var reduced = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var variants = [];
  try { variants = JSON.parse(($("[data-variants]") || {}).textContent || "[]"); } catch (e) {}

  /* pictures */
  var stage = $("[data-stage]"), thumbs = $$("[data-thumb]"), dots = $$(".ntd-prod__dots i");
  var show = function (i, smooth) {
    if (!stage) return;
    var slide = stage.children[i];
    if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: smooth && !reduced ? "smooth" : "auto" });
  };
  var mark = function (i) {
    thumbs.forEach(function (t, k) { if (k === i) t.setAttribute("aria-current", "true"); else t.removeAttribute("aria-current"); });
    dots.forEach(function (d, k) { d.classList.toggle("on", k === i); });
  };
  thumbs.forEach(function (t) { t.addEventListener("click", function () { var i = +t.getAttribute("data-thumb"); show(i, true); mark(i); }); });
  if (stage) stage.addEventListener("scroll", function () {
    var i = Math.round(Math.abs(stage.scrollLeft) / Math.max(1, stage.clientWidth));
    mark(i);
  }, { passive: true });

  /* options → variant */
  var idInput = $("[data-variant-id]"), price = $("[data-price]"), stock = $("[data-stock]");
  var add = $("[data-add-main]"), addLabel = $("[data-add-label]");
  var stickyPrice = $("[data-sticky-price]"), stickyAdd = $("[data-sticky-add]");
  var money = function (c) { return window.NTD && NTD.money ? NTD.money(c) : "QAR " + c / 100; };
  var T = (window.NTD && NTD.t) || {};
  var addWord = addLabel ? addLabel.textContent : "Add to cart";
  function current() {
    var picked = $$("[data-opt]:checked").map(function (i) { return i.value; });
    return variants.filter(function (v) { return picked.every(function (val, k) { return v.options[k] === val; }); })[0];
  }
  function update(v) {
    if (!v) return;
    if (idInput) idInput.value = v.id;
    var html = (v.compare_at_price > v.price ? "<s>" + money(v.compare_at_price) + "</s>" : "") + money(v.price);
    if (price) price.innerHTML = html;
    if (stickyPrice) stickyPrice.textContent = money(v.price);
    if (add) add.disabled = !v.available;
    if (stickyAdd) stickyAdd.disabled = !v.available;
    if (addLabel) addLabel.textContent = v.available ? addWord : (T.sold_out || "Sold out");
    if (stock) stock.classList.toggle("is-out", !v.available);
    if (v.featured_media && stage) {
      var slide = stage.querySelector('[data-media="' + v.featured_media.id + '"]');
      if (slide) { var i = +slide.getAttribute("data-slide"); show(i, true); mark(i); }
    }
    if (window.history && history.replaceState && !window.NTD_PREVIEW) {
      var u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(null, "", u.pathname + u.search + u.hash);
    }
  }
  $$("[data-opt]").forEach(function (i) { i.addEventListener("change", function () { update(current()); }); });

  /* quantity */
  var qty = $("[data-qty-input]");
  $$("[data-qty]").forEach(function (b) {
    b.addEventListener("click", function () { qty.value = Math.max(1, Math.min(99, (+qty.value || 1) + (+b.getAttribute("data-qty")))); });
  });

  /* Add to cart without leaving the page */
  var form = $(".ntd-prod__form");
  if (form) form.addEventListener("submit", function (e) {
    var submitter = e.submitter;
    if (submitter && submitter.closest(".shopify-payment-button")) return;      // Buy it now = Shopify's own checkout
    var N = window.NTD || {};
    if (!N.addToCart) return;                                                   // no shared script: the form posts to /cart/add as usual
    e.preventDefault();
    if (!idInput || add.disabled) return;
    var img = stage && stage.children[Math.round(Math.abs(stage.scrollLeft) / Math.max(1, stage.clientWidth))];
    add.classList.add("is-busy");
    N.addToCart(idInput.value, Math.max(1, +qty.value || 1), null, img && img.querySelector("img"), null).then(function () {
      add.classList.remove("is-busy"); add.classList.add("is-done");
      if (addLabel) addLabel.textContent = T.added || "Added";
      setTimeout(function () { add.classList.remove("is-done"); if (addLabel) addLabel.textContent = addWord; }, 1800);
    });
  });

  /* the phone bar */
  var bar = $("[data-sticky]");
  if (bar && add) {
    var onScroll = function () {
      var r = add.getBoundingClientRect(), on = r.bottom < 0 || r.top > window.innerHeight;   // shown whenever the main button is off screen
      bar.classList.toggle("is-on", on);
      bar.setAttribute("aria-hidden", on ? "false" : "true");
      if (stickyAdd) stickyAdd.tabIndex = on ? 0 : -1;
    };
    window.addEventListener("scroll", onScroll, { passive: true }); onScroll();
    if (stickyAdd) stickyAdd.addEventListener("click", function () { if (form.requestSubmit) form.requestSubmit(add); else add.click(); });
  }
})();
